// removed by extract-text-webpack-plugin
module.exports = {"list":"ReasonsDropdownList__list___1o0uy"};